module.exports = __webpack_public_path__ + "img/cover.fb3c1b66.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover.jpeg
// module id = ht1s
// module chunks = 1